function formatDate(dateString) {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  const date = new Date(dateString)
  const day = date.getDate()
  const month = months[date.getMonth()]
  const year = date.getFullYear()

  const suffix = getDaySuffix(day)

  return `${day}${suffix} ${month} ${year}`
}

function getDaySuffix(day) {
  if (day >= 11 && day <= 13) {
    return 'th'
  }
  switch (day % 10) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}

function convertToTitleCase(str) {
  // List of common small words to be kept lowercase unless they appear at the beginning or end
  const smallWords = /^(a|an|and|as|at|but|by|for|if|in|nor|of|on|or|so|the|to|up|via|vs|with)$/i

  return str
    .toLowerCase()
    .replace(/(?:^|\s)\w/g, function (match) {
      return match.toUpperCase()
    })
    .replace(smallWords, function (match) {
      return match.toLowerCase()
    })
}

const disableRightClick = e => {
  e.preventDefault()
}

const createTypewriter = options => {
  const {
    words = [], // Array of words to type
    baseText = '', // Base text to prepend to the typed words
    typingSpeed = 150, // Speed of typing each character (in ms)
    deletingSpeed = 50, // Speed of deleting each character (in ms)
    pauseDuration = 1500, // Pause duration after typing a word (in ms)
    onUpdate // Callback function to update the displayed text
  } = options

  // If no words provided or empty array, return a no-op typewriter
  if (!words || words.length === 0) {
    return {
      start: () => onUpdate(baseText), // Immediately set baseText
      stop: () => {} // No-op stop function
    }
  }

  let currentWordIndex = 0 // Index of the current word being typed
  let currentCharIndex = 0 // Index of the current character being typed
  let isDeleting = false // Flag to indicate whether we are deleting characters

  const typeWriter = () => {
    const currentWord = words[currentWordIndex] // Get the current word to type

    if (!isDeleting) {
      // Typing characters
      if (currentCharIndex <= currentWord.length) {
        // Add the next character to the baseText and update
        onUpdate(baseText + currentWord.substring(0, currentCharIndex))
        currentCharIndex++ // Move to the next character
      } else {
        // Finished typing the word, start deleting after a pause
        isDeleting = true
        setTimeout(() => {
          typeWriter()
        }, pauseDuration)
        return
      }
    } else {
      // Deleting characters
      if (currentCharIndex > 0) {
        // Remove the last character and update
        onUpdate(baseText + currentWord.substring(0, currentCharIndex - 1))
        currentCharIndex-- // Move to the previous character
      } else {
        // Finished deleting, move to the next word
        isDeleting = false
        currentWordIndex = (currentWordIndex + 1) % words.length // Loop back to the first word if at the end
      }
    }

    // Set the timeout for the next step based on whether typing or deleting
    const timeout = isDeleting ? deletingSpeed : typingSpeed
    setTimeout(typeWriter, timeout)
  }

  return {
    start: typeWriter, // Start the typewriter effect
    stop: () => {
      // Cleanup can be added here if needed
    }
  }
}

const normalizeSingleLensData = data => {
  if (!data || typeof data !== 'object') return {}

  const { wishlist = {}, ...rest } = data

  const { id: wishlistId, ...wishlistWithoutId } = wishlist

  return {
    ...rest, // includes top-level 'id'
    lensId: wishlistId, // renamed wishlist.id
    ...wishlistWithoutId // all other wishlist fields
  }
}

function sortFocalLengths(arr) {
  return arr.sort((a, b) => {
    const numA = parseFloat(a)
    const numB = parseFloat(b)
    return numA - numB
  })
}

export {
  formatDate,
  convertToTitleCase,
  disableRightClick,
  createTypewriter,
  normalizeSingleLensData,
  sortFocalLengths
}
